// extracted by mini-css-extract-plugin
export default {"wrapper":"FormInput_wrapper__HVk6g","input":"FormInput_input__pwNj6"};